import localhost from "apis/localhost";
import { JSON_CONTENT_TYPE, OPPORTUNITY_SEARCH_TYPE } from "constants/app";
import { showErrorModal } from "slices/app/actions/error";

import { setCurrentResults, setTotalResults } from "../opportunitiesSlice";
import { getSourceConfig } from "./sourceConfig";

const HEADERS = {
  headers: {
    "Content-Type": JSON_CONTENT_TYPE,
  },
};

export const fetchUnfilteredTotal =
  (type = OPPORTUNITY_SEARCH_TYPE.SAM_GOV) =>
  async (dispatch) => {
    const { summaryUrl } = getSourceConfig(type);

    try {
      const rsp = await localhost.post(summaryUrl, {}, HEADERS);
      dispatch(setTotalResults(rsp?.data || 0));
    } catch (err) {
      dispatch(showErrorModal(err));
    }
  };

const fetchSearchTotals =
  (filters = {}, type = OPPORTUNITY_SEARCH_TYPE.SAM_GOV) =>
  async (dispatch, getState) => {
    const { summaryUrl } = getSourceConfig(type);

    try {
      const rsp = await localhost.post(summaryUrl, { ...filters }, HEADERS);
      const count = rsp?.data || 0;
      dispatch(setCurrentResults(count));

      if (
        getState().opportunity?.opportunities?.totalResults === 0 && // If not downloaded yet
        Object.entries(filters).length === 0 // If done for all data
      ) {
        dispatch(setTotalResults(count));
      }
    } catch (err) {
      console.error(err);
    }
  };

export default fetchSearchTotals;
